import React from 'react'
import { connect } from 'react-redux'
import classNames from 'classnames'

import { setActiveModal } from 'data/ui/actions'

export type ModalLinkProps = React.LinkHTMLAttributes<HTMLAnchorElement> & {
  to: string
  setActiveModal: (
    options: { id: string; meta?: object; analytics?: object }
  ) => void
  children?: React.ReactNode
  meta?: object
  disabled?: boolean
  analytics?: object
}

const ModalLink = ({
  to,
  children,
  setActiveModal,
  meta,
  className,
  disabled,
  analytics,
  ...linkProps
}: ModalLinkProps) => (
  <a
    className={classNames(className, { pointer: !disabled })}
    {...linkProps}
    onClick={
      !setActiveModal || disabled
        ? undefined
        : event => {
            event.stopPropagation()
            event.preventDefault()
            setActiveModal({ id: to, meta, analytics })
          }
    }
  >
    {children}
  </a>
)

export default connect(
  null,
  { setActiveModal }
)(ModalLink)
